// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c5bfab14","455":"a9124e4b","977":"184c0395"}[chunkId] + ".chunk.js";
};